import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signup, login } from '../api/authService';
import { AUTH_TOKEN_KEY } from '../utils/constants';

interface User {
  _id: string;
  name: string;
  email: string;
  phone?: string;
}

const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [user, setUser] = useState<User | null>(() => {
    // Initialize user from localStorage if available
    const storedUser = localStorage.getItem('userData');
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const navigate = useNavigate();

  const handleSignup = async (userData: {
    name: string;
    email: string;
    phone: string;
    password: string;
  }) => {
    setLoading(true);
    setError(null);

    try {
      const response = await signup(userData);

      if (response.status >= 400) {
        setError(response.message);
        return false;
      }

      if (response.token && response.data) {
        localStorage.setItem(AUTH_TOKEN_KEY, response.token);
        // Save user data with consistent key and include all fields
        const userDataToSave = {
          ...response.data,
          phone: userData.phone // Ensure phone number is included
        };
        localStorage.setItem('userData', JSON.stringify(userDataToSave));
        setUser(userDataToSave);
      }

      navigate('/login', {
        state: {
          message: response.message || 'Account created successfully! Please sign in.',
        },
      });
      return true;
    } catch (err: any) {
      setError(err.message || 'Failed to sign up');
      return false;
    } finally {
      setLoading(false);
    }
  };

const handleLogin = async (credentials: { email: string; password: string }) => {
  setLoading(true);
  setError(null);

  try {
    const response = await login(credentials);
     console.log('Login response:', response);
    if (response.status >= 400) {
      setError(response.message);
      return false;
    }
    let userData = null
    if (response.token && response.data) {
      // Store token and user data
      console.log('Login response:', response.data);
      localStorage.setItem('AUTH_TOKEN', response.token);
      // Ensure phone number is included in saved user data
      const userDataToSave = {
        ...response.data,
        phone: response.data.phone || '' // Ensure phone field exists
      };
      localStorage.setItem('userData', JSON.stringify(userDataToSave));
      setUser(userDataToSave);
      userData = userDataToSave;
     }
      
      if(!userData) {
        setError('User data not found');
        return false;
      }else {
        // Navigate to the dashboard after successful login
        if ((userData as any).isAdmin) {
 navigate('/dashboard');
        }else{
           navigate('/user-dashboard');
        }
       
      }
    return true;
  } catch (err: any) {
    setError(err.message || 'Failed to login');
    return false;
  } finally {
    setLoading(false);
  }
};


  const logout = () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem('userData');
    setUser(null);
    navigate('/login');
  };

  return {
    loading,
    error,
    user,
    handleSignup,
    handleLogin,
    logout,
  };
};

export default useAuth;
